import loadPolyfills from '../brighteon/load_polyfills';
import { start } from '../brighteon/common';

start();

function loaded() {
  const AccountActionContainer = require('../brighteon/containers/account_action_container').default;
  const React = require('react');
  const ReactDOM = require('react-dom');
  const mountNode = document.getElementById('brighteon-account-action');

  if (mountNode !== null) {
    const props = JSON.parse(mountNode.getAttribute('data-props'));
    const accountId = mountNode.getAttribute('data-account');

    ReactDOM.render(<AccountActionContainer {...props} accountId={accountId} />, mountNode);
  }
}

function main() {
  const ready = require('../brighteon/ready').default;
  ready(loaded);
}

loadPolyfills().then(main).catch(error => {
  console.error(error);
});
